<template>
  <div class="validation-field">
    <slot></slot>
    <div class="validation-field__error">
      <span>{{ error }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, computed } from 'vue'

const props = defineProps({
  errors: {
    type: Array<string>,
    default: () => [],
  },
})

const { errors } = toRefs(props)

const error = computed(() => {
  if (errors.value?.length > 0) {
    return errors.value[0]
  }
  return ''
})
</script>

<style scoped lang="scss">
.validation-field {
  position: relative;
  display: flex;
  flex-direction: column;

  &__error {
    position: absolute;
    display: flex;
    width: 100%;
    height: 16px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--color-text-accent);
    top: 100%;
  }
}
</style>
